import * as tslib_1 from "tslib";
import { Value } from '@swim/recon';
var DirectiveForm = (function () {
    function DirectiveForm() {
    }
    DirectiveForm.addGlobal = function (directiveForm) {
        DirectiveForm.Global = DirectiveForm.Global.withDirectiveForm(directiveForm);
    };
    DirectiveForm.removeGlobal = function (directiveForm) {
        DirectiveForm.Global = DirectiveForm.Global.withoutDirectiveForm(directiveForm);
    };
    DirectiveForm.Global = undefined;
    return DirectiveForm;
}());
export { DirectiveForm };
var PolyDirectiveForm = (function (_super) {
    tslib_1.__extends(PolyDirectiveForm, _super);
    function PolyDirectiveForm(directiveForms) {
        var _this = _super.call(this) || this;
        _this._directiveForms = directiveForms;
        return _this;
    }
    Object.defineProperty(PolyDirectiveForm.prototype, "tag", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    PolyDirectiveForm.prototype.directiveForms = function () {
        return this._directiveForms.slice(0);
    };
    PolyDirectiveForm.prototype.withDirectiveForm = function (directiveForm) {
        if (this._directiveForms.indexOf(directiveForm) < 0) {
            var newDirectiveForms = this._directiveForms.slice(0);
            newDirectiveForms.push(directiveForm);
            return new PolyDirectiveForm(newDirectiveForms);
        }
        else {
            return this;
        }
    };
    PolyDirectiveForm.prototype.withDirectiveForms = function () {
        var directiveForms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            directiveForms[_i] = arguments[_i];
        }
        var newDirectiveForms = this._directiveForms.slice(0);
        for (var i = 0; i < directiveForms.length; i += 1) {
            var directiveForm = directiveForms[i];
            if (newDirectiveForms.indexOf(directiveForm) < 0) {
                newDirectiveForms.push(directiveForm);
            }
        }
        if (this._directiveForms.length !== newDirectiveForms.length) {
            return new PolyDirectiveForm(newDirectiveForms);
        }
        else {
            return this;
        }
    };
    PolyDirectiveForm.prototype.withoutDirectiveForm = function (directiveForm) {
        var i = this._directiveForms.indexOf(directiveForm);
        if (i >= 0) {
            var newDirectiveForms = this._directiveForms.slice(0);
            newDirectiveForms.splice(i, 1);
            return new PolyDirectiveForm(newDirectiveForms);
        }
        else {
            return this;
        }
    };
    PolyDirectiveForm.prototype.cast = function (item) {
        if (typeof item === 'string') {
            item = Value.parseRecon(item);
        }
        for (var i = 0; i < this._directiveForms.length; i += 1) {
            var directiveForm = this._directiveForms[i];
            var directive = directiveForm.cast(item);
            if (directive !== undefined) {
                return directive;
            }
        }
        return undefined;
    };
    return PolyDirectiveForm;
}(DirectiveForm));
export { PolyDirectiveForm };
DirectiveForm.Global = new PolyDirectiveForm([]);
//# sourceMappingURL=data:application/json;base64,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